import request from '../request';
import config from '../config';


var current = config.url;
// var current = location.origin+'/';

// function current {
// 	// console.log(current);
// 	// return current+'/';
// 	return config.url;

// }

function retHeaderWithoutToken() {
	const header = {
		'agent': localStorage.getItem("agentCode"),
		'Access-Control-Allow-Origin': '*',
		'Content-Type': 'application/json',
	};
	return header

}
function retHeader() {
	const header = {
		'Authorization': 'Bearer' + localStorage.getItem("gamingToken"),
		'agent': localStorage.getItem("agentCode"),
		'Access-Control-Allow-Origin': '*',
		'Content-Type': 'application/json',
	};
	return header

}
// function retHeaderFile() {
// 	const header = {
// 		'Authorization': 'Bearer' + localStorage.getItem("gamingToken"),
// 		'Access-Control-Allow-Origin': '*',
// 		'Content-Type': 'multipart/form-data',
// 	};
// 	return header

// }

export function platformAll() {
	const data = request({
		url: current + 'api/platform/all',
		method: 'get',
		headers: retHeaderWithoutToken()
	});

	return Promise.resolve(data);
}
export function platformList() {
	const data = request({
		url: current + 'api/platform/list',
		method: 'get',
		headers: retHeader()
	});

	return Promise.resolve(data);
}

export function login(postData) {
	const data = request({
		url: current + 'api/login/v2',
		method: 'post',
		data: postData,
		headers: retHeaderWithoutToken()
	});

	return Promise.resolve(data);
}

export function getMemberInfo() {
	const data = request({
		url: current + 'api/me',
		method: 'get',
		headers: retHeader()
	});

	return Promise.resolve(data);
}

export function getGameBalance(platform_id) {
	const data = request({
		url: current + `api/platform/balance/${platform_id}`,
		method: 'get',
		headers: retHeader()
	});

	return Promise.resolve(data);
}

export function getGameLink(platform_id) {
	const data = request({
		url: current + `api/platform/launch/${platform_id}`,
		method: 'get',
		headers: retHeader()
	});

	return Promise.resolve(data);
}

export function gameDeposit(platform_id, postData) {
	const data = request({
		url: current + `api/platform/deposit/${platform_id}`,
		method: 'post',
		data: postData,
		headers: retHeader()
	});

	return Promise.resolve(data);
}

export function gameWithdraw(platform_id, postData) {
	const data = request({
		url: current + `api/platform/withdraw/${platform_id}`,
		method: 'post',
		data: postData,
		headers: retHeader()
	});

	return Promise.resolve(data);
}

export function balanceLog() {
	const data = request({
		url: current + `api/inAmount/log`,
		method: 'get',
		headers: retHeader()
	});

	return Promise.resolve(data);
}

export function allNumber() {
	const data = request({
		url: current + `api/allNumber`,
		method: 'get',
		headers: retHeader()
	});

	return Promise.resolve(data);
}

export function deposit(postData) {
	const data = request({
		url: current + `api/payment/deposit`,
		method: 'post',
		data: postData,
		headers: retHeader()
	});

	return Promise.resolve(data);
}

export function getPaymentList() {
	const data = request({
		url: current + `api/payment/list`,
		method: 'get',
		headers: retHeader()
	});

	return Promise.resolve(data);
}

export function dropAmount(postData) {
	const data = request({
		url: current + `api/dropAmount`,
		method: 'post',
		data: postData,
		headers: retHeader()
	});

	return Promise.resolve(data);
}

export function getMTGames(platform_id) {
	const data = request({
		url: current + `api/platform/games/${platform_id}`,
		method: 'get',
		headers: retHeader()
	});

	return Promise.resolve(data);
}

export function getMTGameLink(game_id) {
	const data = request({
		url: current + `api/platform/launch/22/${game_id}`,
		method: 'get',
		headers: retHeader()
	});

	return Promise.resolve(data);
}

export function getUsdtAddressList() {
	const data = request({
		url: current + `api/usdtAddress/list`,
		method: 'get',
		headers: retHeader()
	});

	return Promise.resolve(data);
}

export function withdraw(postData) {
	const data = request({
		url: current + `api/payment/withdraw`,
		method: 'post',
		data: postData,
		headers: retHeader()
	});

	return Promise.resolve(data);
}

export function createAddress(postData) {
	const data = request({
		url: current + `api/usdtAddress/create`,
		method: 'post',
		data: postData,
		headers: retHeader()
	});

	return Promise.resolve(data);
}

export function homeBanner(web_id) {
	const data = request({
		url: current + `api/homeBanner?web_id=${web_id}`,
		method: 'get',
		headers: retHeaderWithoutToken()
	});

	return Promise.resolve(data);
}

export function announcement(web_id) {
	const data = request({
		url: current + `api/announcement?web_id=${web_id}`,
		method: 'get',
		headers: retHeaderWithoutToken()
	});

	return Promise.resolve(data);
}

export function depositRecord() {
	const data = request({
		url: current + `api/deposit/record`,
		method: 'get',
		headers: retHeader()
	});

	return Promise.resolve(data);
}

export function withdrawRecord() {
	const data = request({
		url: current + `api/withdraw/record`,
		method: 'get',
		headers: retHeader()
	});

	return Promise.resolve(data);
}

export function getRules() {
	const data = request({
		url: current + `api/rebate/rule`,
		method: 'get',
		headers: retHeader()
	});

	return Promise.resolve(data);
}

export function getRebateRecord() {
	const data = request({
		url: current + `api/rebate/record`,
		method: 'get',
		headers: retHeader()
	});

	return Promise.resolve(data);
}





